// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sprigatito: PokeData = {
  "id": 906,
  "name": "sprigatito",
  "height": 4,
  "weight": 41,
  "base_experience": 62,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "scratch",
    "tail-whip",
    "bite",
    "quick-attack",
    "slash",
    "magical-leaf",
    "u-turn",
    "worry-seed",
    "seed-bomb",
    "energy-ball",
    "hone-claws",
    "play-rough",
    "leafage"
  ],
  "moves": [
    "scratch",
    "bite",
    "quick-attack",
    "energy-ball",
    "play-rough",
    "bullet-seed",
    "power-whip",
    "leaf-tornado",
    "synthesis",
    "flower-rush",
    "wood-hammer",
    "razor-leaf",
    "vine-whip"
  ],
  "evolution_chain": {
    "id": 478,
    "item": null,
    "species": [
      {
        "name": "sprigatito",
        "order": 906,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "floragato",
        "order": 907,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 906,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "meowscarada",
        "order": 908,
        "types": [
          PokeType.GRASS,
          PokeType.DARK
        ],
        "evolves_from_species_id": 907,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 44.75,
    "speed": 65,
    "ability_power": 61
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
